<template>
    <div>
        <Loading :value="loading" ></Loading>
        <span class="title">Liste des contrats des employés</span>
        <v-divider class="mb-3"></v-divider>

        <v-layout row justify-space-between>
            <v-expansion-panel focusable popout value="0" >
                <v-expansion-panel-content >
                    <template v-slot:header>
                        <v-toolbar color="green" dark  >
                            <v-toolbar-title   >{{contratsEnCours.length}} contrats(s) en cours</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </template>
                    <v-card>
                        <v-card-text class="green lighten-5">
                            <v-layout row wrap align-center v-if="contratsEnCours.length > 0">

                                <v-flex xs12 md3 mb-3 pl-2 v-for="contrt in contratsEnCours">
                                    <modelCarteContrat @contAnnule="loadContrat()" @detailEmpl="showDetailEmploye" :contrat="contrt" ></modelCarteContrat>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-expansion-panel-content>

                <v-expansion-panel-content>
                    <template v-slot:header>
                        <v-toolbar color="orange" dark>
                            <v-toolbar-title>{{contratsArenouveller.length}} contrats(s) à renouveler </v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </template>
                    <v-card>
                        <v-card-text class="orange lighten-5">
                            <v-layout row wrap align-center v-if="contratsArenouveller.length > 0">

                                <v-flex xs12 md3 mb-3 pl-2  v-for="contratAr in contratsArenouveller">
                                    <modelCarteContrat @contAnnule="loadContrat()" @detailEmpl="showDetailEmploye" :contrat="contratAr" ></modelCarteContrat>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-expansion-panel-content>

                <v-expansion-panel-content>
                    <template v-slot:header>
                        <v-toolbar color="red" dark>
                            <v-toolbar-title>{{contratsExpire.length }} contrats(s) expiré(s)</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </template>
                    <v-card>
                        <v-card-text class="red lighten-5">
                            <v-layout row wrap align-center v-if="contratsExpire.length > 0">

                                <v-flex xs12 md3 mb-3 pl-2  v-for="contratEx in contratsExpire">
                                    <modelCarteContrat @contAnnule="loadContrat()" @detailEmpl="showDetailEmploye" :contrat="contratEx" ></modelCarteContrat>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-expansion-panel-content>

                <v-expansion-panel-content color="blue" >
                    <template v-slot:header>
                        <v-toolbar color="blue" dark>
                            <v-toolbar-title>{{contratsInactif.length }} contrats(s) inactif(s)</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </template>
                    <v-card>
                        <v-card-text class="blue lighten-5">
                            <v-layout row wrap align-center v-if="contratsInactif.length > 0">

                                <v-flex xs12 md3 mb-3 pl-2  v-for="contratInact in contratsInactif">
                                    <modelCarteContrat @contAnnule="loadContrat()" @detailEmpl="showDetailEmploye" :contrat="contratInact" ></modelCarteContrat>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-expansion-panel-content>

                <v-expansion-panel-content>
                    <template v-slot:header>
                        <v-toolbar color="grey" dark>
                            <v-toolbar-title>{{contratsAnnule.length}} contrats(s) annulé(s)</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </template>
                    <v-card>
                        <v-card-text class="grey lighten-5">
                            <v-layout row wrap align-center v-if="contratsAnnule.length > 0">
                                <v-flex xs12 md3 mb-3 pl-2  v-for="contratAn in contratsAnnule">
                                    <modelCarteContrat @contAnnule="loadContrat()" @detailEmpl="showDetailEmploye" :contrat="contratAn" ></modelCarteContrat>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-expansion-panel-content>

            </v-expansion-panel>


        </v-layout>



        <!--Modal detail employe-->
            <modalDetailEmploye  @close="showDetailEmpl = false" :show="showDetailEmpl" :userIdContrat="employSelect" ></modalDetailEmploye>
        <!--Modal detail employe-->
    </div>
</template>

<script>
    import Loading from '@/components/Loading';
    import modalDetailEmploye from '@/components/resourceHumaine/modalDetailEmploye'
    import modelCarteContrat from '@/components/resourceHumaine/modelCarteContrat'
    export default {
        components: {Loading,modalDetailEmploye,modelCarteContrat},
        name: "listeContrat",
        data(){
            return {
                notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
                domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
                droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
                loading: false,

                contratEmployes: [],
                contratsEnCours: [],
                contratsArenouveller: [],
                contratsExpire: [],
                contratsAnnule: [],
                contratsInactif: [],
                showDetailEmpl: false,
                employSelect: null

            }
        },
        methods:{
            loadContrat(){
                this.loading = true;
                let url = this.domaine+ "rh/contrat/all";

                this.$http.get(url).then(resp => {
                    this.loading = false;
                    this.contratEmployes = resp.body.listeContrats;
                    this.contratsArenouveller = this.contratEmployes.filter(cont => {
                        return cont.etat == 2
                    })


                    this.contratsEnCours = this.contratEmployes.filter((cont) => {
                        return cont.etat == 0
                    })

                    this.contratsInactif = this.contratEmployes.filter(cont => {
                        return cont.etat == 1
                    })

                    this.contratsExpire = this.contratEmployes.filter(cont => {
                        return cont.etat == 3
                    })

                    this.contratsAnnule = this.contratEmployes.filter(cont => {
                        return cont.etat == 4
                    })
                }, error => {
                    this.loading = false;
                    this.$message.error("Echec lors du chargement des contrats")
                })
            },
            showDetailEmploye(idEmploye){
                this.employSelect = idEmploye
                this.showDetailEmpl = true
            }
        },
        mounted(){
           this.loadContrat();
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/resourceHumaine/liste_contrat.vue